export class Coordinates {
  public top: number;
  public left: number;

  constructor(top: number, left: number) {
    this.left = left;
    this.top = top;
  }
}
